import styled from 'styled-components';

import { warningYellowIcon } from '#/assets';
import { useRfqBuilderView } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/view';

export default function Warning() {
  const view = useRfqBuilderView();

  const firstFutureLeg = view.legs.find((leg) => leg.kind === 'FUTURE');
  if (firstFutureLeg == null) return null;

  const isDrfq = view.auction.selectedOption.value === 'RFQ';

  const productCode = firstFutureLeg.product.selectedOption?.value;
  if (productCode == null) return null;

  return isDrfq ? (
    <WarningContainer>
      <ContractSizeWarning />
    </WarningContainer>
  ) : (
    <span />
  );
}

const WarningContainer = styled.div`
  padding: 5px 10px;
  font-size: 12px;
`;

function ContractSizeWarning() {
  return (
    <>
      <Icon />
      <PrimaryMessage>
        All Qty units are in clearing currency terms.
      </PrimaryMessage>{' '}
      <SecondaryMessage>
        Exchange & product specific contract multipliers are not applied.
      </SecondaryMessage>
    </>
  );
}

const Icon = styled.img.attrs({ src: warningYellowIcon, alt: 'warning' })`
  width: 18px;
  margin-right: 7px;
  margin-top: -1px;
`;
const PrimaryMessage = styled.span`
  color: #fff;
`;
const SecondaryMessage = styled.span`
  color: rgba(255, 255, 255, 0.5);
`;
